export const PAGE_PATH = '/expenditure';
